import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { generateDiffStrings } from 'utils/func/diffString';
import DiffColumn from '../DiffColumn';

export default function HardProductCompareTable({ products1, products2, diffObj }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <tr>
      <td>
        <div
          className="my-2 p-datatable p-component
            p-datatable-responsive-scroll p-datatable-scrollable p-datatable-gridlines p-datatable-gridlines"
          data-scrollselectors=".p-datatable-wrapper"
        >
          <div className="p-datatable-wrapper">
            <table className="p-datatable-table">
              <thead className="p-datatable-thead">
                <tr>
                  <th style={{ textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.order'
                    )}
                  </th>
                  <th style={{ minWidth: '8rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.productName'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityCriteria'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.measure'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }} colSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityLevel'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.expectedQuantity'
                    )}
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: 'center' }} rowSpan="2">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.evaluativeCriteria'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }} colSpan="2">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.similarModel'
                    )}
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: 'center' }}>
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.domestic'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.international'
                    )}
                  </th>
                </tr>
              </thead>
              <tbody className="p-datatable-tbody">
                {products1?.map((_, index) => (
                  <tr key={products1?.[index]?.id ?? index}>
                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                    <td>
                      {
                        generateDiffStrings(products1?.[index]?.name, products2?.[index]?.name)
                          ?.left
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.qualityCriteria,
                          products2?.[index]?.qualityCriteria
                        )?.left
                      }
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {
                        generateDiffStrings(
                          products1?.[index]?.measure,
                          products2?.[index]?.measure
                        )?.left
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.evaluativeCriteria,
                          products2?.[index]?.evaluativeCriteria
                        )?.left
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.domesticModelQuality,
                          products2?.[index]?.domesticModelQuality
                        )?.left
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.internationalModelQuality,
                          products2?.[index]?.internationalModelQuality
                        )?.left
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.expectedQuantity,
                          products2?.[index]?.expectedQuantity
                        )?.left
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </td>
      <td>
        <div
          className="my-2 p-datatable p-component
            p-datatable-responsive-scroll p-datatable-scrollable p-datatable-gridlines p-datatable-gridlines"
          data-scrollselectors=".p-datatable-wrapper"
        >
          <div className="p-datatable-wrapper">
            <table className="p-datatable-table">
              <thead className="p-datatable-thead">
                <tr>
                  <th style={{ textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.order'
                    )}
                  </th>
                  <th style={{ minWidth: '8rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.productName'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityCriteria'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.measure'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }} colSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityLevel'
                    )}
                  </th>
                  <th style={{ maxWidth: '6rem', textAlign: 'center' }} rowSpan="3">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.expectedQuantity'
                    )}
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: 'center' }} rowSpan="2">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.evaluativeCriteria'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }} colSpan="2">
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.similarModel'
                    )}
                  </th>
                </tr>
                <tr>
                  <th style={{ textAlign: 'center' }}>
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.domestic'
                    )}
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    {t(
                      'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.international'
                    )}
                  </th>
                </tr>
              </thead>
              <tbody className="p-datatable-tbody">
                {products2?.map((_, index) => (
                  <tr key={products2?.[index]?.id ?? index}>
                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                    <td>
                      {
                        generateDiffStrings(products1?.[index]?.name, products2?.[index]?.name)
                          ?.right
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.qualityCriteria,
                          products2?.[index]?.qualityCriteria
                        )?.right
                      }
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {
                        generateDiffStrings(
                          products1?.[index]?.measure,
                          products2?.[index]?.measure
                        )?.right
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.evaluativeCriteria,
                          products2?.[index]?.evaluativeCriteria
                        )?.right
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.domesticModelQuality,
                          products2?.[index]?.domesticModelQuality
                        )?.right
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.internationalModelQuality,
                          products2?.[index]?.internationalModelQuality
                        )?.right
                      }
                    </td>
                    <td>
                      {
                        generateDiffStrings(
                          products1?.[index]?.expectedQuantity,
                          products2?.[index]?.expectedQuantity
                        )?.right
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </td>
      <DiffColumn
        isDifferent={Object.values(diffObj ?? {})?.some(
          (item) =>
            item === true ||
            item?.name === true ||
            item?.qualityCriteria === true ||
            item?.measure === true ||
            item?.evaluativeCriteria === true ||
            item?.domesticModelQuality === true ||
            item?.internationalModelQuality === true ||
            item?.expectedQuantity === true
        )}
      />
    </tr>
  );
}

HardProductCompareTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products1: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  products2: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  diffObj: PropTypes.object.isRequired,
};
